import './toggle-button.scss';

( function( $ ) {

	$( function() {

		$( '.a-toggleButton' ).each( function() {

			const $toggle = $( this );
			const $items = $toggle.find( 'button.a-toggleButton__item' );

			// Check if this toggle is being used as tabs (has role="tab" attribute)
			const isTabSystem = $items.first().attr( 'role' ) === 'tab';
			
			// Skip base toggle behavior if this is part of a tab system
			if ( isTabSystem ) {
				return;
			}

			// Check if this toggle is connected to radio inputs (has data-name attribute)
			const radioName = $toggle.attr( 'data-name' );
			const isRadioToggle = !! radioName;

			$items.on( 'click', function( e ) {

				e.preventDefault();

				const $clicked = $( this );

				// Remove active class from all items
				$items.removeClass( '-active' ).attr( 'aria-pressed', 'false' );

				// Add active class to clicked item
                $clicked.addClass( '-active' ).attr( 'aria-pressed', 'true' );

				// If this toggle is connected to radios, trigger the corresponding radio
				if ( isRadioToggle ) {
					const radioValue = $clicked.attr( 'data-radio-value' );
					if ( radioValue ) {
						const $radio = $( 'input[name="' + radioName + '"][value="' + radioValue + '"]' );
						if ( $radio.length ) {
							// Set checked and trigger change event
							// This will trigger LiveForm refresh via existing change handlers in archive.js
							$radio.prop( 'checked', true ).trigger( 'change' );
							
							// Update label active state
							$( 'label' ).removeClass( 'active' );
							$radio.closest( 'label' ).addClass( 'active' );
							
							// Trigger form refresh for LiveForm
							// LiveForm should auto-refresh on radio change, but we ensure it happens
							const $form = $radio.closest( 'form' );
							if ( $form.length && $form.attr( 'id' ) === 'entity-search-form' ) {
								// Trigger refresh via custom event that archive.js can listen to
								// This ensures form.refresh() is called even if LiveForm doesn't auto-refresh
								$form.trigger( 'toggle-button:refresh' );
							}
						}
					}
				}

			} );

		} );

	} );

} )( jQuery );
